import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'element-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🌳 Element</h1>
            <p class='section-text' tabindex='0'>
                <b>Element</b> is the Mosaic option we use to tell the component
                where to inject itself when we start our application. You can either
                set this option to a string representing the ID of an existing DOM node
                or to a reference to an existing DOM node. Typically this will be done
                in a div with the ID "root" or something similar.
            </p>
            <span class='section-text'><i style='color:gray;margin-bottom:0px'>index.html</i></span>
            <code-segment type='JS'>
                &lt;html&gt;
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&lt;body&gt;
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &lt;div id='root'&gt;&lt;/div&gt;
                <br><br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &lt;script src='./index.js'&gt;&lt;/script&gt;
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;&lt;/body&gt;
                <br>
                &lt;/html&gt;
            </code-segment>

            <span class='section-text'><i style='color:gray;margin-bottom:0px'>index.js</i></span>
            <code-segment type='JS'>
                new Mosaic({
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;name: 'my-component',
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;element: 'root'
                <br>
                })
            </code-segment>
            <span class='section-text'><i style='color:gray;margin-bottom:0px'>or</i></span>
            <br><br>
            <code-segment type='JS'>
                new Mosaic({
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;name: 'my-component',
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;element: document.getElementById("root")
                <br>
                })
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>
                paint(arg?: <span style='color:mediumseagreen'>string, DOM node, or data object</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                The <b>paint</b> function is used to add your Mosaic component to the DOM
                so it can be seen on your computer screen. Calling "paint" will immediately
                add the component as a child of the existing DOM node specified by the 
                "element" option. If you did not specify the "element" property directly on 
                your component, however, you can set it as a parameter in the paint function 
                at call time. You can also inject data at paint time by passing in an object
                to the paint function.
            </p>
            <p class='section-text' tabindex='0'>
                Interestingly enough, though, the paint function is not necessarily the only
                way to inject your components into the DOM. Remember that calling "new Mosaic"
                will return to you an instance of your newly created component, so if you want
                to you can just call "document.body.appendChild()" and pass in the component
                instance returned by the call to the Mosaic function.
            </p>
            <code-segment type='JS'>
                const app = new Mosaic({
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;name: 'my-component',
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;element: document.getElementById("root")
                <br>
                });
                <br><br>
                app.paint();
            </code-segment>
            
            <br>
            <p class='section-text' tabindex='0' style="text-align: center;">
                Next we will move on to the lifecycle functions that you can
                specify on your components.
            </p>

            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/naming')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Naming your Components
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/lifecycle')}'>
                    Lifecycle Hooks
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});